import { useEffect, useRef, useState } from 'react';
import ImagenBannerALUBIN from '../../assets/images/ALUBIN.png';
import './ALUBIN.css';
import Facebok from '../../assets/images/Facebok.png';
import Wasa from '../../assets/images/Wasa.png';
import insta from '../../assets/images/insta.png';
import Telefono from '../../assets/images/Telefono.png';
import Ubi from '../../assets/images/Ubi.png';
import Email34 from '../../assets/images/Correo.png';
import RedesFondo from '../../assets/images/Red-Neuronal.png';
import checkAnim from '../../assets/images/check.gif';

function ALUBIN() {

    
  return (
    <>
    <div className="infra-banner-ALUBIN">
  <img src={ImagenBannerALUBIN} alt="ALUBIN" className="banner-img-ALUBIN" />
    <h1 className="banner-texto-ALUBIN">ALUBIN</h1>
</div>
<div className="fondo-blanco-ALUBIN">
<div className="contenedor-ALUBIN">
  <div className="columna-izquierda-ALUBIN">
    <h1>SECTOR:</h1>
    <p>ALUMINIO</p>
    <h1>PAIS:</h1>
    <p>MÉXICO</p>
    <h1>EMPRESA:</h1>
      <p>Alubin de México es una empresa especializada en la extrusión de perfiles de aluminio, con operaciones dentro del Parque Industrial Toluca 2000. Su infraestructura de última generación incluye planta de pintura, procesos de anodizado y recubrimientos metálicos, permitiéndole fabricar productos con acabados técnicos de alta calidad, durabilidad y precisión.
      <br></br>
      <br></br>
      Al formar parte del ecosistema de Grupo Tecnovidrio, Alubin integra soluciones que combinan aluminio y vidrio arquitectónico, ofreciendo propuestas competitivas para sectores como la construcción, energía, automotriz, industrial y arquitectónico. Con un enfoque en innovación, diseño y manufactura avanzada, la empresa se posiciona como un actor clave en el crecimiento del desarrollo urbano e infraestructura nacional.
    </p>
    <div className="boton-reto">
      <a href="https://www.immsa.mx/" className="btn-reto-ALUBIN">Ver más información</a>
    </div>
  </div>

  <div className="columna-derecha-ALUBIN">
   <h2>RETO: DASHBOARD EN FABRICACIÓN.</h2>
    <p>El reto consiste en diseñar cuadros de mando inteligentes y funcionales que permita visualizar en tiempo real los indicadores clave de desempeño (KPIs) en la producción de aluminio.</p>

    <h2>SOLUCIÓN IMPLEMENTADA: </h2>
    <p>Nuestra experiencia en la producción de aluminio fue clave para ofrecer al cliente una visión clara, dinámica y sostenible de los indicadores empresariales. <br></br>
    <br></br>
    Si bien es fundamental partir de las metas que cada departamento desea alcanzar, en este proyecto propusimos un enfoque distinto: desarrollar indicadores que no solo reflejen el destino, sino que también orienten el camino hacia las metas. <br></br>
    <br></br>
    Esta perspectiva permite ajustar las operaciones en tiempo real, reduciendo las desviaciones entre lo planeado y lo ejecutado. <br></br>
    <br></br>
    Gracias a este enfoque, se diseñaron indicadores estratégicos que permitieron identificar áreas de mejora en toda la cadena de producción: desde la entrega de materiales por parte de los proveedores, la gestión de tiempos en movimientos internos, la planeación de la fabricación, los tiempos de operación, el uso de maquinaria, los recursos humanos, hasta la logística de entrega al cliente. <br></br>
    <br></br>
    El resultado fue un éxito tangible: los indicadores se convirtieron en herramientas clave para optimizar los procesos tanto administrativos como operativos, generando mejoras sostenibles en la eficiencia de la empresa.
</p>

    <h2>RESEÑA</h2>
    <p>Pendiente.</p>
  </div>
</div>
</div>

{/* Contenedor principal  de pie de página con contacto*/}

<div className="contacto-footer-nuevo">
  <div className="footer-contenido-nuevo">
    {/* Fondo completo con redes */}
  <img src={RedesFondo} alt="Fondo redes" className="redes-fondo-completa" />
    {/* Columna 1: Contacto */}
    <div className="footer-columna-nueva">
  <h4>CONTACTO GRUPO IATEKZA</h4>

  <div className="footer-item">
    <img src={Ubi} alt="Ubi" className="footer-icono" />
    <p>Circon 5, Colonia El Pedregal de <br /> Atizapán, Estado de México, C.P. 52948.</p>
  </div>

  <div className="footer-item">
    <img src={Telefono} alt="Teléfono" className="footer-icono" />
    <p>+52 55 5335 5810</p>
  </div>

  <div className="footer-item">
    <img src={Email34} alt="Correo" className="footer-icono" />
    <p>ventas@iatekza.com</p>
  </div>
</div>


    {/* Columna 2: Servicios */}
    <div className="footer-columna-nueva">
      <h4>Conoce nuestros servicios</h4>
      <ul>
        <li><a href="/">• IAutomatiza CFDI</a></li>
        <li><a href="/Comercializacion">• Infraestructura TI</a></li>
        {/* Servicio Consultoria ERP LIBRA colum 2*/}
        <li><a href="/Consultoria">• Asesoría Empresarial</a></li>
        {/* Servicio Sistemas colum 2*/}
        <li><a href="/Sistemas">• Sistemas</a></li>
      </ul>
      <div className="iconos-redes-nuevos">
        <a href="https://www.facebook.com/profile.php?id=61577085653032&locale=es_LA/" target="_blank" rel="noopener noreferrer">
          <img src={Facebok} alt="Facebook" />
        </a>
        <a href="https://api.whatsapp.com/send?phone=5215567786252&text=Hola, me gustaría más información acerca de:" target="_blank" rel="noopener noreferrer">
          <img src={Wasa} alt="WhatsApp" />
        </a>
        <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
          <img src={insta} alt="Instagram" />
        </a>
      </div>
    </div>

    {/* Columna 3: Información general */}
    <div className="footer-columna-nueva">
      <h4>Información General</h4>
      <ul>
        <li><a href="/CasosExito">Ver Mas Casos de Éxito</a></li>
        <li><a href="/Nosotros">Sobre nosotros</a></li>
        <li><a href="/Legal">Aviso Legal</a></li>
      </ul>
    </div>
  </div>

  <div className="footer-bottom-nuevo">
    <p>© Grupo IAtekza 2025 – Todos los derechos reservados</p>
  </div>
</div>

</>
  );
}

export default ALUBIN;